import React from 'react';

const ShareIcon = function() {
  return (
    <svg
      className={'share'}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 14 13"
      fill="none"
    >
      <line
        x1="2.46447"
        y1="5.9404"
        x2="11.301"
        y2="1.81987"
        stroke="#BCBCBC"
      />

      <line
        y1="-0.5"
        x2="9.75"
        y2="-0.5"
        transform="matrix(0.906308 0.422618 0.422618 -0.906308 2.61865 6.5)"
        stroke="#BCBCBC"
      />

      <path
        d="M3.30273 6.5C3.30273 7.39746 2.5752 8.125 1.67773 8.125C0.780272 8.125 0.0527344 7.39746 0.0527344 6.5C0.0527344 5.60254 0.780272 4.875 1.67773 4.875C2.5752 4.875 3.30273 5.60254 3.30273 6.5Z"
        fill="#BCBCBC"
      />

      <circle cx="11.4277" cy="1.625" r="1.625" fill="#BCBCBC" />

      <circle cx="11.4277" cy="11.375" r="1.625" fill="#BCBCBC" />
    </svg>
  );
};

export default ShareIcon;